module.exports = __webpack_public_path__ + "img/advertise.d2c978a7.png";